import { hotTopics } from "@/mocks/content";

export default function RankingSection() {
  return (
    <section id="trend" className="scroll-mt-16 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary-500">Hot Ranking</p>
          <h2 className="font-display mt-2 text-3xl text-foreground-950 md:text-4xl">吃瓜热度排行</h2>
          <p className="mt-2 text-sm text-foreground-600">
            根据全网讨论量综合计算，直击当下最受关注的十件大事。
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-[1.3fr_0.7fr]">
          {/* full list */}
          <ol className="grid content-start gap-3 sm:grid-cols-2">
            {hotTopics.map((t, i) => (
              <li
                key={t.rank}
                className={`flex items-start gap-3 rounded-xl border p-4 transition-colors hover:bg-background-50 ${
                  i % 2 === 0 ? "border-background-200 bg-background-50" : "border-transparent"
                }`}
              >
                <span
                  className={`font-display mt-0.5 text-2xl leading-none ${
                    t.rank <= 3 ? "text-primary-500" : "text-background-400"
                  }`}
                >
                  {String(t.rank).padStart(2, "0")}
                </span>
                <div className="min-w-0 flex-1">
                  <a href="#feed" className="line-clamp-2 text-sm font-semibold text-foreground-900 hover:text-primary-600">
                    {t.title}
                  </a>
                  <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-400">
                    <span className={`inline-flex items-center gap-0.5 rounded px-1.5 py-0.5 text-[11px] font-bold text-background-50 ${t.levelColor}`}>
                      {t.level}
                    </span>
                    <span className="flex items-center gap-0.5">
                      <i className="ri-fire-line text-primary-400"></i>
                      {t.heat}
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </ol>

          {/* side callout */}
          <div className="flex flex-col justify-center rounded-2xl bg-gradient-to-br from-primary-600 to-primary-700 p-7 text-background-50">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-background-50/15">
              <i className="ri-line-chart-line text-2xl"></i>
            </span>
            <h3 className="font-display mt-4 text-2xl leading-snug">读懂热点，才能跟上节奏</h3>
            <p className="mt-3 text-sm leading-relaxed text-background-50/85">
              热度只是起点。榜单上每一件大事的背后，都藏着当代年轻人的情绪、审美与选择。关注色瓜网，和千万网友一起，把热闹看明白。
            </p>
            <a
              href="#feed"
              className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-lg bg-background-50 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-secondary-200"
            >
              去信息流看看
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}